import { NavigationButton } from '../components/models/NavigationButton';

/** A titled group of sidebar navigation items (Console v2). */
export interface NavigationGroup {
  /** Transloco key of the group title; omitted for the main (untitled) group */
  titleKey?: string;
  items: NavigationButton[];
}

/**
 * Console v2 sidebar navigation — order and grouping per mockups-v2.
 * Route targets are unchanged (deep links keep working).
 */
export const navigationGroups: NavigationGroup[] = [
  {
    items: [
      {
        location: '',
        translation: 'layout.nav.home',
        icon: 'dashboard',
      },
    ],
  },
  {
    titleKey: 'layout.groups.loyalty',
    items: [
      {
        location: 'customer-loyalty',
        translation: 'layout.nav.members',
        icon: 'groups',
      },
      {
        location: 'transactions',
        translation: 'layout.nav.transactions',
        icon: 'receipt_long',
      },
    ],
  },
  {
    titleKey: 'layout.groups.communication',
    items: [
      {
        location: 'coupons',
        translation: 'layout.nav.coupons',
        icon: 'local_offer',
      },
      {
        location: 'announcements',
        translation: 'layout.nav.announcements',
        icon: 'mail',
      },
      {
        location: 'promotions',
        translation: 'layout.nav.promotions',
        icon: 'campaign',
      },
      {
        location: 'notifications',
        translation: 'layout.nav.pushMessages',
        icon: 'notifications',
      },
    ],
  },
  {
    titleKey: 'layout.groups.settings',
    items: [
      {
        location: 'loyalty-programs',
        translation: 'layout.nav.loyaltyPrograms',
        icon: 'loyalty',
      },
      {
        location: 'locations',
        translation: 'layout.nav.locations',
        icon: 'place',
      },
      {
        location: 'staff',
        translation: 'layout.nav.users',
        icon: 'group',
      },
      {
        location: 'settings',
        translation: 'layout.nav.settings',
        icon: 'settings',
      },
    ],
  },
];

/**
 * Flat navigation list kept for legacy consumers
 * (e.g. HeaderComponent on the public policy pages).
 */
export const navigationButtons: NavigationButton[] = navigationGroups.reduce(
  (all, group) => all.concat(group.items),
  [] as NavigationButton[]
);
